import React, { useState } from "react";
import PropTypes from "prop-types";
import { Confirm } from "react-admin";
import { IconButton } from "@material-ui/core";

const ConfirmButton = props => {
  const [open, setOpen] = useState(false);
  const handleClick = e => {
    e.stopPropagation();
    setOpen(true);
  };
  const handleDialogClose = () => setOpen(false);
  const handleConfirm = () => {
    props?.click();
    setOpen(false);
  };

  return (
    <>
      <IconButton {...props} size="small" onClick={handleClick}></IconButton>
      <Confirm
        isOpen={open}
        loading={props?.isLoading}
        title={props?.title ? props.title : ""}
        content={props?.content ? props?.content : "Do you approve of the status change?"}
        confirm="Approve"
        cancel="Cancel "
        onConfirm={handleConfirm}
        onClose={handleDialogClose}
      />
    </>
  );
};

ConfirmButton.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  click: PropTypes.func,
  isLoading: PropTypes.bool,
  ...IconButton.prototype,
};

export default ConfirmButton;
